module.exports = __webpack_public_path__ + "static/media/fam-register.6355b82b.png";